import { render, staticRenderFns } from "./OFormContactComp.vue?vue&type=template&id=d4a57c5c&"
import script from "./OFormContactComp.vue?vue&type=script&lang=js&"
export * from "./OFormContactComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports